import {Translate} from "../../../hooks/translate.hook";
import {ColumnsType} from "antd/lib/table/interface";
import React from "react";
import {Claim, ClaimStatus, ClaimType} from "../../../models/claims/claims";
import {Amount} from "../../../models/prices/price";
import Date from "../../date/date";
import {Link} from "react-router-dom";
import {ClaimsStatus} from "../status/claim.status";
import {displayPrice} from "../../../models/prices/price.helper";

export const columnsFactory = (t: Translate): ColumnsType<Claim> => {
    return [
        {
            title: "ID",
            dataIndex: "id",
            key: "id"
        },
        {
            title: t("TYPE"),
            dataIndex: "type",
            key: "type",
            render: (type: ClaimType) => t("CLAIMS.CLAIM.TYPE." + type.toUpperCase()),
        },
        {
            title: t("NUMBER"),
            dataIndex: "documentNumber",
            key: "documentNumber",
            render: (number: number, claim) => <Link to={"/claims/" + claim.id}>{number}</Link>,
        },
        {
            title: t("CLIENT.NAME"),
            dataIndex: "account",
            key: "account",
            width: "255px",
            render: ({ agent }) => <Link to={"/clients/" + agent.number}>{agent.name}</Link>,
        },
        {
            title: t("STATUS"),
            dataIndex: "status",
            key: "status",
            width: "125px",
            render: (item: ClaimStatus) => <ClaimsStatus status={item} />
        },
        {
            title: t("DATE"),
            dataIndex: "documentDate",
            key: "documentDate",
            render: (item: string) => <Date dateString={item} showTime />
        }
    ];
}